import Splide from '@splidejs/splide';

export const slider = {
  mounted(el) {
    new Splide(el, {
      arrows: false,
    }).mount();
  },
};
